import React, {useState} from 'react';
import AssetMarker from "./AssetMarker";
import {MARKER_HEIGHT, MARKER_WIDTH} from "../../utilities";


const AssetMarkers = ({assets, services, proposal_services, spriteUrl, markerOrigins}) => {
    const [selectedAssetId, setSelectedAssetId] = useState(null);
    return assets.map((asset, i) => {
        const origin = markerOrigins[asset.id]?.origin;
        if (!origin || !spriteUrl) return null;
        const icon = {
            url: spriteUrl,
            size: new google.maps.Size(MARKER_WIDTH, MARKER_HEIGHT),
            origin: new google.maps.Point(origin.x, origin.y),
            anchor: new google.maps.Point(MARKER_WIDTH / 2, MARKER_HEIGHT),
        }

        return <AssetMarker asset={asset} icon={icon} proposal_services={proposal_services} services={services} index={i}
                            selected={asset.selected}
                            id={asset.id}
                            onClick={setSelectedAssetId}
                            isOtherAssetSelected={selectedAssetId && selectedAssetId !== asset.id}/>
    })

}
export default AssetMarkers;